import { ReactNode } from 'react';
import clsx from 'clsx';

interface IIconButtonProps {
  className?: string;
  /**
   * Icon to be displayed inside the button
   */
  icon: ReactNode;
  /**
   * Click handler
   */
  onClick: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * It renders an icon button with a click handler. It looks round in the shape.
 */
export function IconButton({
  className,
  icon,
  onClick,
}: Readonly<IIconButtonProps>) {
  return (
    <button
      className={clsx(
        `
          flex h-12 w-12 cursor-pointer items-center justify-center rounded-full
           bg-gray-100 transition-all duration-500 ease-in-out
          hover:scale-110  hover:border-2 hover:border-green-950/20 hover:bg-green-50
        `,
        className
      )}
      onClick={onClick}
      type="button"
    >
      {icon}
    </button>
  );
}
